import { useMemo } from 'react';
import { cond, constant } from 'lodash-es';

const DEFAULT_COLOR_RULES = [
  { threshold: 1, color: 'red-50' },
  { threshold: 3, color: 'blue-50' },
  { threshold: 5, color: 'green-50' },
];

const defaultCreateBarHeightCb = barId => barId * 3 + 4.5;

export function useRatingBar({
  value: { rating, maxRating },
  colorRules = DEFAULT_COLOR_RULES,
  createBarHeight = defaultCreateBarHeightCb,
}) {
  const activeColor = useMemo(() => {
    const conditions = colorRules.map(({ threshold, color }) => [() => rating <= threshold, constant(color)]);
    return cond(conditions)();
  }, [colorRules, rating]);

  const bars = useMemo(
    () => Array.from({ length: maxRating }, (_, i) => ({ id: i + 1, height: createBarHeight(i + 1) })),
    [createBarHeight, maxRating]
  );

  return { activeColor, bars };
}
